import { useCmsConfigStore } from '@/stores/cms/cmsConfigStore'
import { useLandingPageStore } from '@/stores/landingPage/landingPageStore'
import { useServiceModeStore } from '@/stores/serviceMode/serviceModeStore'

export const applyDeviceSettingsFromBootstrap = () => {
  const { cmsConfig } = useCmsConfigStore()

  if (!cmsConfig?.deviceSettings) {
    return
  }

  useServiceModeStore().syncFromDeviceSettings(cmsConfig.deviceSettings)
  useLandingPageStore().syncFromDeviceSettings(cmsConfig.deviceSettings)
}
